var gMap;
var gMapMarker;
var gMapAutocomplete;
var foundAddress = {
    'geo_latitude': '',
    'geo_longitude': '',
    'geo_street': '',
    'geo_housenumber': '',
    'geo_zip': '',
    'geo_city': ''
};
var gMapStyling = [
    {
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "weight": 3
            }
        ]
    },
    {
        "featureType": "administrative.country",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#959595"
            }
        ]
    },
    {
        "featureType": "administrative.country",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#333333"
            }
        ]
    },
    {
        "featureType": "administrative.land_parcel",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#333333"
            }
        ]
    },
    {
        "featureType": "administrative.locality",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#4b4b4b"
            }
        ]
    },
    {
        "featureType": "administrative.neighborhood",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#959595"
            }
        ]
    },
    {
        "featureType": "administrative.province",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#959595"
            }
        ]
    },
    {
        "featureType": "administrative.province",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#959595"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry",
        "stylers": [
            {
                "saturation": 60
            }
        ]
    },
    {
        "featureType": "landscape.man_made",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "lightness": -5
            }
        ]
    },
    {
        "featureType": "landscape.man_made",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "lightness": 10
            }
        ]
    },
    {
        "featureType": "landscape.man_made",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#999999"
            }
        ]
    },
    {
        "featureType": "landscape.natural",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "saturation": -75
            },
            {
                "lightness": 25
            }
        ]
    },
    {
        "featureType": "landscape.natural",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#c1c1c1"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit.line",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#b5b5b5"
            }
        ]
    },
    {
        "featureType": "transit.line",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#a8a8a8"
            },
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit.station",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#c1c1c1"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#81d9fd"
            },
            {
                "saturation": -40
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels",
        "stylers": [
            {
                "color": "#417d98"
            }
        ]
    }
];
// var gMapStyling = [];

function initAutocomplete() {
    gMapAutocomplete = new google.maps.places.Autocomplete(
        /** @type {!HTMLInputElement} */(document.getElementById('gMap_autocomplete_input')),
        {types: ['geocode']}
    );

    google.maps.event.addListener(gMapAutocomplete, 'place_changed', function () {
        $('#gMap_autocomplete_confirm').click();
    });

    if(country === "AT") {
        gMapAutocomplete.setComponentRestrictions({'country': ['at']});
    } else {
        gMapAutocomplete.setComponentRestrictions({'country': ['de']});
    }
}

function placeMarker(location, doGetAddressFromLatLng, doCenterOnMarker) {
    if(typeof gMapMarker != 'undefined') {
        gMapMarker.setPosition(location);
    } else {
        gMapMarker = new google.maps.Marker({
            map: gMap,
            icon: '/img/gmap_icon.png',
            position: location,
            draggable:true,
            animation: google.maps.Animation.DROP
        });

        gMapMarker.addListener('dragend', function(event) {
            getAddressFromLatLng(gMapMarker.getPosition());
        });
    }

    if(doCenterOnMarker === true) {
        gMap.setZoom(17);
        gMap.panTo(location);
    }
    if(doGetAddressFromLatLng === true) {
        getAddressFromLatLng(location);
    }
}

function getGeoFromAddress() {
    var reverseGeoCodeUrl = 'https://maps.googleapis.com/maps/api/geocode/json';
    var data = {
        address: $('#geo_street').val() + " " + $('#geo_housenumber').val() + ", " + $('#geo_zip').val() + " " + $('#geo_city').val(),
        key: 'AIzaSyC8j0N3Job71ZZYVOL8zarA68RD0d7BLow'
    };

    $.get(reverseGeoCodeUrl, data)
        .done(function( data ) {
            var firstResult = data.results[0];
            if(firstResult.geometry.location) {
                $('#geo_latitude').val(firstResult.geometry.location.lat);
                $('#geo_longitude').val(firstResult.geometry.location.lng);
                placeMarker(firstResult.geometry.location, false, true);
            }
        });
}

function getAddressFromLatLng(location) {
    foundAddress = {
        'geo_latitude': location.lat(),
        'geo_longitude': location.lng(),
    };

    var reverseGeoCodeUrl = 'https://maps.googleapis.com/maps/api/geocode/json';
    var data = {
        latlng: location.lat()+','+location.lng(),
        key: 'AIzaSyC8j0N3Job71ZZYVOL8zarA68RD0d7BLow'
    };
    $.get(reverseGeoCodeUrl, data)
        .done(function( data ) {
            var firstResult = data.results[0];
            fillAdressComponentsToFormFields(firstResult.address_components);
        });
}

function fillInAutoCompleteAddress() {
    var place = gMapAutocomplete.getPlace();

    if(place.geometry) {
        foundAddress = {
            'geo_latitude': place.geometry.location.lat(),
            'geo_longitude': place.geometry.location.lng(),
        };
        placeMarker(place.geometry.location, false, true);
    }
    if(place.address_components) {
        fillAdressComponentsToFormFields(place.address_components);
    }
}

function fillAdressComponentsToFormFields(addressComponents) {

    var configuratorPage = false;
    if ($('body').attr("id") === 'bodyConfigurator') {
        configuratorPage = true;
    }

    foundAddress.geo_housenumber = '';
    foundAddress.geo_street = '';
    foundAddress.geo_zip = '';
    foundAddress.geo_city = '';

    for(var i in addressComponents){
        for(var j in addressComponents[i].types){
            if (!configuratorPage || (configuratorPage && !$('#geo_street').val())) {
                if (addressComponents[i].types[j] === 'street_number') {
                    foundAddress.geo_housenumber = addressComponents[i].long_name;
                } else if (addressComponents[i].types[j] === 'route') {
                    foundAddress.geo_street = addressComponents[i].long_name;
                } else if (addressComponents[i].types[j] === 'sublocality_level_2' && foundAddress.geo_street == null) {
                    foundAddress.geo_street = addressComponents[i].long_name;
                } else if (addressComponents[i].types[j] === 'postal_code') {
                    foundAddress.geo_zip = addressComponents[i].long_name;
                } else if (addressComponents[i].types[j] === 'locality') {
                    foundAddress.geo_city = addressComponents[i].long_name;
                }
            }
        }
    }

    fillAutocompleteString(foundAddress);

    $('#gMap').removeClass('disabled');
    $('#bottomnavigation .right button').removeClass('button-disabled');

    $.each(foundAddress, function (key, val) {
        $('#'+key).val(val);
    });
    resizeIframe();
}

function fillAutocompleteString(foundAddress) {
    let autocompleteValue = '';
    if(foundAddress.geo_street !== '') {
        autocompleteValue = foundAddress.geo_street;
    }
    if(foundAddress.geo_housenumber !== '') {
        if(autocompleteValue !== '') {
            autocompleteValue += ' ';
        }
        autocompleteValue += foundAddress.geo_housenumber;
    }
    if(autocompleteValue !== '' && (foundAddress.geo_zip !== '' || foundAddress.geo_city !== '')) {
        autocompleteValue += ', ';
    }
    if(foundAddress.geo_zip !== '') {
        autocompleteValue += foundAddress.geo_zip;
    }
    if(foundAddress.geo_city !== '') {
        if(foundAddress.geo_zip !== '') {
            autocompleteValue += ' ';
        }
        autocompleteValue += foundAddress.geo_city;
    }
    $('#gMap_autocomplete_input').val(autocompleteValue);
}

function initMapOffer(listener) {
    var gMapOptions = {
        zoom: 18,
        center: geoMapLocation,
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControl: true,
        zoomControl: true,
        styles: gMapStyling
    };

    gMap = new google.maps.Map(document.getElementById('gMap'), gMapOptions);

    google.maps.event.addListener(gMap, 'click', function (event) {
        placeMarker(event.latLng, true, true);
    });

    initAutocomplete();
}

function initMapSummary() {
    var gMapOptions = {
        zoom: 18,
        center: geoMapLocation,
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControl: true,
        gestureHandling: 'none',
        zoomControl: false,
        styles: gMapStyling
    };

    gMap = new google.maps.Map(document.getElementById('gMap'), gMapOptions);
    placeMarkerStatic(geoMapLocation);
}

function placeMarkerStatic(location) {
    gMapMarker = new google.maps.Marker({
        map: gMap,
        icon: '/img/gmap_icon.png',
        position: location,
        draggable:false,
        animation: google.maps.Animation.DROP
    });
}

function initMap(listener) {
    var gMapOptions = {
        zoom: 7,
        center: {
            lat: 51.165691,
            lng: 10.451526
        },
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControl: true,
        styles: gMapStyling
    };

    if(country === "AT") {
        gMapOptions['center'] = {
            lat: 47.516232,
            lng: 14.550072
        }
    }

    gMap = new google.maps.Map(document.getElementById('gMap'), gMapOptions);

    google.maps.event.addListener(gMap, 'click', function (event) {
        placeMarker(event.latLng, true, false);
    });

    initAutocomplete();
}

function debounce(func, timeout = 300){
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
}
const debouncedAjaxValidation = debounce((currentElement, whatToValidate) => ajaxValidation(currentElement, whatToValidate), 200);

function ajaxValidation(currentElement, whatToValidate = 'useValue') {
    var data = {
        name: currentElement.attr("name"),
        value: currentElement.val()
    };

    if(whatToValidate === 'useChecked') {
        data['value'] = currentElement.is(":checked");
    }

    $.post("./scripts/htmlincludes/ajaxValidation.php", data, function (jsonresult) {
        // everything's fine --> remove error class
        // console.log('Success', jsonresult);
        currentElement.closest('.formrow').removeClass('notValid');
    }, "json")
        .fail(function(response) {
            // validation failed --> add error class
            // console.log('Error', response.responseText);
            currentElement.closest('.formrow').addClass('notValid');
        });
}

$(function(){

    var elemGeoLatitude = $('#geo_latitude');
    var elemGeoLongitude = $('#geo_longitude');
    if(elemGeoLatitude.length && elemGeoLatitude.val() !== '' &&
        elemGeoLongitude.length && elemGeoLongitude.val() !== '') {
        setTimeout(function() {
            placeMarker({ lat: parseFloat(elemGeoLatitude.val()), lng: parseFloat(elemGeoLongitude.val()) }, false, true);
        }, 500);
    } else {
        $('#gMap_autocomplete_container').slideDown();
    }

    //Disable HTML5 Validation on "BACK"
    $('#submitBtnBack').click(function() {
        $(this).closest('form').attr('novalidate', 'novalidate');
    });

    $('#geo_housenumber, #geo_street, #geo_zip, #geo_city').change(function(){
        if ($('body').attr("id") === 'bodyConfigurator') {
            getGeoFromAddress();
        }
    });

    //Number input
    $(".form-number-input input").each(function(e) {
        let currentValue = parseInt($(this).val());
        if($(this).attr('min') !== undefined) {
            if(currentValue <= parseInt($(this).attr('min'))) {
                $(this).parent().find('.control.minus').addClass('disabled');
            }
        }
        if($(this).attr('max') !== undefined) {
            if(currentValue >= parseInt($(this).attr('max'))) {
                $(this).parent().find('.control.plus').addClass('disabled');
            }
        }
    });
    $(".form-number-input").find(".control").click(function(e){
        e.preventDefault();

        var self = $(this);
        var input = self.closest(".form-number-input").find("input");
        var inputMin = input.attr('min');
        var inputMax = input.attr('max');
        var newValue = parseInt(input.val());
        if(isNaN(newValue)) newValue = 0;

        $('.form-number-input .control').removeClass('disabled');

        if(self.hasClass("plus")){
            newValue++;
            if(!isNaN(inputMax) && newValue > inputMax) {
                newValue = inputMax;
            }
            if((newValue + 1) > inputMax) {
                $(this).addClass('disabled');
            }
        } else {
            newValue--;
            if(!isNaN(inputMin) && newValue < inputMin) {
                newValue = inputMin;
            } else if(newValue < 0) {
                newValue = 0;
            }
            if((newValue - 1) < inputMin) {
                $(this).addClass('disabled');
            }
        }
        input.val(newValue).trigger('change');
        if(input.attr('id') === 'house_floors') {
            showHideFloorsAddInfo(newValue);
        }
    });

    //Array input
    $(".form-array-input").find(".control").click(function(e){
        e.preventDefault();

        let self = $(this);
        let parentElem = self.closest(".form-array-input");
        let allowedValues = JSON.parse(atob(parentElem.data('allowedvalues')));
        let input = parentElem.find("input");
        let valueDisplay = parentElem.find("span.valueDisplay");
        let currentValue = input.val();

        parentElem.find('.control').removeClass('disabled');

        let newValue;
        if(!allowedValues.includes(currentValue)) {
            newValue = 1;
        } else {
            let currentIndex = allowedValues.indexOf(currentValue);
            let newIndex;
            if(self.hasClass("plus")){
                newIndex = currentIndex + 1;
                if(newIndex >= allowedValues.length - 1) {
                    newIndex = allowedValues.length - 1;
                    $(this).addClass('disabled');
                }
            } else {
                newIndex = currentIndex - 1;
                if(newIndex <= 0) {
                    newIndex = 0;
                    $(this).addClass('disabled');
                }
            }
            newValue = allowedValues[newIndex];
        }
        valueDisplay.html(newValue);
        input.val(newValue).trigger('change');

        if(input.attr('id') === 'household_persons') {
            newValue = newValue.replace('+', 'plus');
            $('.personImg').attr('src', 'img/persons_2024_' + newValue + '.svg?v=2');
        }
    });

    //Slider
    let elemSliderOutside = $(".slider")
        .slider({
            range: "min",
            create: function(event, ui) {
                $(this).slider('option', 'max', $(this).data('max'));
                $(this).slider('option', 'min', $(this).data('min'));
                $(this).slider('option', 'value', $(this).data('value'));
                $(this).slider('option', 'step', $(this).data('step'));
            },
            slide: function(event, ui){
                var hiddenInput = $(this).closest(".form-slider").find("input[type=hidden]");
                hiddenInput.val(ui.value).trigger('change');

                var sliderValue = $(this).closest(".form-slider").find(".form-slider-value .value input");
                sliderValue.val(ui.value);
            }
        })
        .on('slidechange', function(event, ui) {
            $(this).closest('.form-slider').find('.form-slider-value .value input').val(ui.value);
        });
    $('.form-slider-value .value input').change(function() {
        elemSliderOutside.slider('value', $(this).val());
    });

    //DropDown
    $('.select2dropdown').select2({
        minimumResultsForSearch: Infinity
    });

    $(".ajaxValidation input[type=text], .ajaxValidation input[type=number], .ajaxValidation input[type=email]").blur(function() { ajaxValidation( $(this), 'useValue' ); });
    $(".ajaxValidation .form-number-input input[type=text], .ajaxValidation input[type=radio], .ajaxValidation select").change(function() { ajaxValidation( $(this), 'useValue' ); });
    $(".ajaxValidation input[type=hidden]").change(function() { debouncedAjaxValidation( $(this), 'useValue' ); });
    $(".ajaxValidation input[type=checkbox]").change(function() { ajaxValidation( $(this), 'useChecked' ); });
});

function normalizeString(inputString) {
    if (typeof inputString === 'undefined') {
        return '';
    } else {
        return inputString
            .toLowerCase()
            .replace(/ /g, '')
            .replace(/-/g, '')
            .replace(/_/g, '')
            .replace(/\u00dc/g, "ue")
            .replace(/\u00fc/g, "ue")
            .replace(/\u00c4/g, "ae")
            .replace(/\u00e4/g, "ae")
            .replace(/\u00d6/g, "oe")
            .replace(/\u00f6/g, "oe")
            .replace(/\u00df/g, "ss");
    }
}